import * as React from 'react';

import { ILocalization } from '@shared-ui/localization-context';

import { UitkSelect } from 'uitk-react-input';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkText } from 'uitk-react-text';

import { StaticTimeSelectOptions } from './car-pickup-dropoff-time-options';

interface TimeSelectProps {
  label: string;
  invalid?: string;
  value: string;
  formattedDate: string;
  l10n: ILocalization;
  domRef?: any;
  id?: string;
  onChange?: (event: any) => void;
}

export const CarPickUpDropOffTimeSelect: React.FunctionComponent<TimeSelectProps> = React.memo(
  ({ label, id, invalid, value, formattedDate = '\u00A0', onChange, l10n, domRef = null }) => (
    <div id={`${id}-label`} className="multi-item-time-select">
      <UitkSpacing padding={{ block: 'two' }}>
        <div>
          <UitkText align="left" size={300}>
            {formattedDate}
          </UitkText>
        </div>
      </UitkSpacing>
      <UitkSelect aria-labelledby={`${id}-label`} icon="access_time" name={id} {...{ label, value, invalid, domRef, onChange, id }}>
        <StaticTimeSelectOptions l10n={l10n} />
      </UitkSelect>
    </div>
  )
);
